(function () {
  "use strict";

  angular.module("alk.filters", []);

  angular.module("alk.filters")
    .filter("fullAddressFilter", [function () { //return an HTML string from an ALK Address result
      // eslint-disable-next-line complexity
      return function (address, returnHtml, linebreaks) {
        returnHtml = returnHtml || false;
        linebreaks = linebreaks || false;
        var addrStr = "";
        let br;
        if (!linebreaks) {
          br = ", ";
        } else if (returnHtml) {
          br = "<br>";
        } else {
          br = "\n";
        }

        if (address.City !== "" && address.City !== null && address.City !== undefined) {
          addrStr += address.City;
        }
        if (address.State !== "" && address.State !== null && address.State !== undefined) {
          addrStr += ", " + address.State;
        }
        if (address.Zip !== "" && address.Zip !== null && address.Zip !== undefined) {
          addrStr += ", " + address.Zip;
        }
        if (address.Country !== "" && address.Country !== null && address.Country !== undefined && address.Country !== "United States") {
          addrStr += ", " + address.Country;
        }

        if (returnHtml) {
          if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
            addrStr = `<strong>${address.StreetAddress}</strong>${br + addrStr}`;
          }
          if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
            addrStr = `<strong>${address.SPLC}</strong>${br + addrStr}`;
          }
        } else {
          if (address.StreetAddress !== "" && address.StreetAddress !== null && address.StreetAddress !== undefined) {
            addrStr = address.StreetAddress + br + addrStr;
          }
          if (address.SPLC !== "" && address.SPLC !== null && address.SPLC !== undefined) {
            addrStr = address.SPLC + br + addrStr;
          }
        }

        return addrStr;
      };
    }]);

  // format output from Links service
  angular.module("alk.filters")
    .filter("getRouteName", function () {
      return function (props, index) {
        var routeName = "";
        var routenums;
        if (!index) index = 0;
        if (props.routenums) {
          routenums = props.routenums;
        } else {
          routenums = props;
        }
        if (typeof routenums === "string") JSON.parse(routenums);
        if (routenums !== "") {
          if (routenums[index].category) routeName += " " + routenums[index].category;
          if (routenums[index].rtnum) routeName += " " + routenums[index].rtnum;
          if (routenums[index].modifier) routeName += " " + routenums[index].modifier;
          if (routenums[index].alpha) routeName += " " + routenums[index].alpha;
          if (routenums[index].compass) routeName += " " + routenums[index].compass;
        }
        return routeName;
      };
    });

  angular.module("alk.filters")
    .filter("concatName", function () {
      return function (names, index) {
        var fullName = "";
        if (typeof names === "string") JSON.parse(names);
        if (names !== "" && names.length > 0) {
          if (names[index].prefix) fullName += " " + names[index].prefix.abbreviation;
          fullName += " " + names[index].name;
          if (names[index].type) fullName += " " + names[index].type.description;
          if (names[index].suffix) fullName += " " + names[index].suffix.abbreviation;
        }
        return fullName;
      }
    });

  angular.module("alk.filters")
    .filter("getFullName", function (concatNameFilter, getRouteNameFilter) {
      return function (props, index) {
        if (_.isUndefined(props) || _.isNull(props)) {
          return "";
        } else {
          if (!index) index = 0;
          var fullName = "";
          if (props.names != null && props.names.length > 0) { // jshint ignore:line
            var names = props.names;
            fullName = concatNameFilter(names, index);
          } else if (props.routenums != null && props.routenums.length > 0) { // jshint ignore:line
            fullName = getRouteNameFilter(props, index);
          } else {
            var names = props;
            fullName = concatNameFilter(names, index);
          }
          if (fullName === "") fullName = "Unnamed";
          return fullName;
        }
      }
    });

  angular.module("alk.filters")
    .filter("coordsToCardinal", function () {
      return function (coords, index) {
        var outputStr = "";
        var xCardinal, yCardinal;
        if (typeof coords !== "undefined") {
          xCardinal = parseFloat(coords.Lon) > 0 ? " E" : " W";
          yCardinal = parseFloat(coords.Lat) > 0 ? " N" : " S";
          outputStr = coords.Lat + yCardinal + ", " + coords.Lon + xCardinal;
        }
        return outputStr;
      }
    });

  angular.module("alk.filters")
    .filter("hexToRGBa", function () {
      return function (hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16),
          g = parseInt(hex.slice(3, 5), 16),
          b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
          return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
        } else {
          return "rgb(" + r + ", " + g + ", " + b + ")";
        }
      };
    });

  angular.module("alk.filters")
    .filter("propsFilter", function () {
      return function (items, props) {
        var out = [];

        if (angular.isArray(items)) {
          items.forEach(function (item) {
            var itemMatches = false;

            var keys = Object.keys(props);
            for (var i = 0; i < keys.length; i++) {
              var prop = keys[i];
              var text = props[prop].toLowerCase();
              if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                itemMatches = true;
                break;
              }
            }

            if (itemMatches) {
              out.push(item);
            }
          });
        } else {
          // Let the output be the input untouched
          out = items;
        }

        return out;
      };
    });

  angular.module("alk.filters")
    .filter("unsafe", ["$sce", function ($sce) {
      return $sce.trustAsHtml;
    }]);

  angular.module("alk.filters")
    .filter("minmax", function () {
      return function (arr, min, max, incr) {
        min = parseInt(min);
        max = parseInt(max);
        incr = parseInt(incr) || 1;
        for (var i = min; i <= max; i += incr) {
          arr.push(i);
        }
        return arr;
      };
    });
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/Common/common-filters.js